var iconloaded = false;

function addActiveClassToLi(selected_text) {
    if (!selected_text) {
        selected_text = jQuery('div.search_region a:first').text();
    }
    jQuery("div.dropcontainer ul li.selected").removeClass('selected');
    jQuery("div.dropcontainer ul li a:contains('" + selected_text + "')").parent('li').addClass('selected');
}

function addLocationIcon() {
    var rect = viewportWidhOnLoad();
    if (jQuery('div.search_region a:first').length > 0) {
        if (rect.width < 768) {
            jQuery('div.search_region a:first').addClass('search_region_icon');
        } else {
            jQuery('div.search_region a:first').removeClass('search_region_icon');

        }
        jQuery('div.dropcontainer ul li a').click(function (event) {
            /*console.log(jQuery('#search_region:input'));*/
            /*console.log(jQuery('#search_region').val());
             jQuery('#search_region_in:input').val(jQuery('#search_region').val());


             var target = jQuery('div.search_region').closest('div.job_listings');

             var form = target.find('.job_filters');
             var inital_page = 1;
             var index = jQuery('div.job_listings').index(target);

             if (window.history.state && window.location.hash) {
             var state = window.history.state;
             if (state.id && 'job_manager_state' === state.id && index === state.index) {
             inital_page = state.page;
             form.deserialize(state.data);
             form.find(':input[name^="search_categories"]').not(':input[type="hidden"]').trigger('chosen:updated');
             }
             }

             */
            /* target.trigger('update_results', [inital_page, false]);*/
            /*

             jQuery('#search_region_in:input').trigger('change');*/
            //job_manager_store_state(target, 1);
        });
        /*console.log(jQuery('#search_region:input').val());
         jQuery('#search_region').change(function () {
         console.log(111);
         jQuery('#search_region_in:input').val(jQuery('#search_region').val());
         jQuery('#search_region_in:input').trigger('change');
         });*/
        iconloaded = true;
    }

}

function msieversion() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        /*alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));*/
        return true;
    }
    else  // If another browser, return 0
    {
        return false;
    }

    return false;
}
jQuery(window).on('load', function () {
    jQuery('.job_filters').each(function () {
        var target = jQuery(this).closest('div.job_listings');
        var form = target.find('.job_filters');
        var inital_page = 1;
        var index = jQuery('div.job_listings').index(target);

        if (window.history.state && window.location.hash) {
            var state = window.history.state;
            if (state.id && 'job_manager_state' === state.id && index === state.index) {
                inital_page = state.page;
                form.deserialize(state.data);
                form.find(':input[name^="search_categories"]').not(':input[type="hidden"]').trigger('chosen:updated');
            }
        }

        target.triggerHandler('update_results', [inital_page, false]);
    });
    /*if (jQuery("#apply-now-form-wrapper").length > 0) {

     if (msieversion()) {
     jQuery("#apply-now-form-wrapper ul").mCustomScrollbar();
     } else {
     jQuery("#apply-now-form-wrapper ul").each(function () {
     new SimpleBar(jQuery(this)[0], {
     autoHide: false
     });
     });
     }
     }*/
    jQuery('#apply-now-form-wrapper').hide();
    jQuery('.application_button').click(function () {
        jQuery('#apply-now-form-wrapper').dialog();
        jQuery('body').css('overflow', 'hidden');

        var refreshIntervalId = setInterval(function () {
            if (jQuery("#apply-now-form-wrapper .dropcontainer").length > 0) {
                if (msieversion()) {
                    jQuery("#apply-now-form-wrapper ul").mCustomScrollbar();
                } else {
                    jQuery("#apply-now-form-wrapper ul").each(function () {
                        new SimpleBar(jQuery(this)[0], {
                            autoHide: false
                        });
                    });
                }
                /*comsole.log(111);*/
                clearInterval(refreshIntervalId);
            }
        }, 100);

        /* later */


    });

    jQuery('#apply-now-form-close').click(function () {
        jQuery('#apply-now-form-wrapper').dialog('close');
        jQuery('body').css('overflow', 'auto');
        if (jQuery('#job-apply-form').length > 0) {
            jQuery('#job-apply-form')[0].reset();
        }
        return false;
    });

    jQuery('#search_submit').click(function () {
        var target = jQuery(this).closest('div.job_listings');
        target.triggerHandler('update_results', [inital_page, false]);
    });
    /*new Select({
     el: jQuery('#search_region'),
     });*/

    jQuery("#job_filters").submit(function () {
        return false;
    });

    setInterval(function () {
        if (!iconloaded) {
            addLocationIcon();
            jQuery('#search_region').removeClass('hide');
            jQuery('div.search_location_wrapper').removeClass('hide');
            addActiveClassToLi();
        }
    }, 50);


});

jQuery(document).ready(function ($) {

    jQuery('#search_region').addClass('turnintodropdown');

    $('div.selected_job_type').click(function () {

        $('ul.job_types').slideToggle();

    });

    $('html').click(function (event) {
        if (event.target.id !== 'selected_job_type') {
            $('ul.job_types').slideUp();
        }
        if (event.target.id !== 'selected_job_category') {
            $('ul.job_categories').slideUp();
        }
    });


    $('div.selected_job_category').click(function () {
        $('ul.job_categories').slideToggle();
    });


    $('.search-submit-btn').click(function () {
        $('.dropcontainer ul').addClass('dropdownhidden').removeClass('dropdownvisible');
    });
});

jQuery(window).resize(function () {
    addLocationIcon();
});






